export const REFERRAL_LINK = "http://ggrus.bet/organicebet/ggbr?param=FIREBASE";